import { render, staticRenderFns } from "./PartsList.vue?vue&type=template&id=dcff9632&lang=pug"
import script from "./PartsList.vue?vue&type=script&lang=js"
export * from "./PartsList.vue?vue&type=script&lang=js"
import style0 from "./PartsList.vue?vue&type=style&index=0&id=dcff9632&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports